export const plantillaImportacionMasiva =
  'https://cloud.isipaid.net/boa/template_boa_V4.xlsx'
